import React from 'react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { Menu, Portal, Button, Flex, Image, Icon, AbsoluteCenter, Container, Box, VStack, Tabs, Center, Link, Text, Float } from '@chakra-ui/react';
import { LuTestTubes as LuSample, LuUsers, LuMenu, LuCircleHelp as LuDocs, LuFileSpreadsheet as LuReports, LuFolderCheck as LuIngest, LuSquareCheck, LuUser, LuSearch, LuTextSearch as LuSearchResults} from "react-icons/lu"

export const sidebarWidth = "7em";

const iconSize = "1.7em";
const iconStrokeWidth = 2.0;
const iconSelectedStrokeWidth = 2.5;
const iconHoverStrokeWidth = 3;

const navItems = [
  {
    path: 'search',
    label: 'BLAST Search',
    icon: LuSearch
  },
  {
    path: 'search_results',
    label: 'Search Results',
    icon: LuSearchResults
  },
  {
    path: 'samples',
    label: 'Samples & Projects',
    icon: LuSample
  },
  {
    path: 'generate_reports',
    label: 'Generate Reports',
    icon: LuReports
  },
];

const superUserNavItems = [
  // {
  //   path: 'ingestion_status',
  //   label: 'Ingestion Status',
  //   icon: LuIngest
  // },
  {
    path: 'user_management',
    label: 'Manage Accounts',
    icon: LuUsers,
  }
]

const helpNavItem = {
  path: 'help',
  label: 'Help',
  icon: LuDocs
}

function NavTab({ icon: Icon, path, label, onClick  }) {
  return (
    <Tabs.Trigger value={path} 
      color="brand.contrast"  
      fontWeight={500}
      _selected={{ bg: 'brand.contrast', fontWeight: "bold",
        '& svg': { color: 'brand.fg', strokeWidth: iconSelectedStrokeWidth }
       }} 
      _hover={{ fontWeight: "bold" ,
        '& svg': {strokeWidth: iconHoverStrokeWidth }
       }}
      onClick={() => onClick(path)}
      height="2.2em"
      justifyContent="center"
      as="button" // Changed from Link to button
      type="button"
    >
      <VStack position="relative" w="100%">
        <Icon size={iconSize} strokeWidth={iconStrokeWidth} />
        <Float placement="bottom-center" w="6em">
          <Text fontSize={"1em"} lineHeight={"1.3em"} textAlign="center" transform="translateY(50%)" pt="0.4em" px="0">{label}</Text>
        </Float>
      </VStack>
    </Tabs.Trigger>
  );
}

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  var selectedTab = location.pathname.substring(1);
  if(selectedTab && selectedTab.startsWith('results')) {
    selectedTab = 'search_results';
  }else if(selectedTab && selectedTab.startsWith('samples')) {
    selectedTab = 'samples';
  }

  const handleNavigation = (path) => {
    navigate(`/${path}`);
  };

  const isLogged = localStorage.getItem('access_token') ? true : false;
  const isSuperuser = localStorage.getItem('is_superuser') === 'true';
  console.log("isSuperuser", isSuperuser);
  console.log("isSuperuser", localStorage.getItem('is_superuser'));
  const _navItems = [];
  if(isLogged){
    _navItems.push(...navItems);
    if (isSuperuser) {
      _navItems.push(...superUserNavItems);
    }
    _navItems.push(helpNavItem);
  }
  

  return (
    <Box
      as="nav"
      w={sidebarWidth}
      h="100%" // full height
      bg="brand.solid"
      // p="1.3em" // padding
      position="fixed"
      overflow="auto" 
    >
      
      

      <Flex justify={"space-between"} direction="column" h="100%" w="100%" >
        <Flex justify="flex-start" direction="column" w="100%" >

          {isLogged &&
            <Menu.Root  w="100%" >
              <Menu.Trigger asChild>
                <Center color="brand.contrast" my="2.0em" p="1.3em" w="100%" _hover={{ fontWeight: "bold" , cursor: 'pointer',
                  '& svg': {strokeWidth: iconHoverStrokeWidth }
                }}>
                  <LuMenu size={iconSize} strokeWidth={iconStrokeWidth}  />
                </Center>
              </Menu.Trigger>
              <Portal>
                <Menu.Positioner >
                  <Menu.Content mt="-1.5em">
                    <Menu.Item value="log-out" asChild>
                      <RouterLink to="/login">
                        Log Out
                      </RouterLink>
                    </Menu.Item>
                    {isSuperuser &&
                    <Menu.Item value="ing-stat" asChild>
                      <RouterLink to="/ingestion_status">
                        Ingestion Status (Superuser Only)
                      </RouterLink>
                    </Menu.Item>
                    }
                  </Menu.Content>
                </Menu.Positioner>
              </Portal>
            </Menu.Root>
          }
          


          <Tabs.Root value={selectedTab} activationMode="manual" orientation='vertical'
            variant="subtle" width="100%" top="-2em" p="1.3em">
            <Tabs.List gap="4em" width="100%" >
              {_navItems.map((item) => (
                <NavTab as="Link"
                  key={item.path} 
                  {...item} 
                  onClick={handleNavigation}
                />
              ))}
            </Tabs.List>
          </Tabs.Root>
        </Flex>
          
        <Flex justify="flex-end" direction="column" w="100%" >
          <Link href="https://lizard.bio/" target='_blank' > 
          <Image src="/images/logo.svg" alt="logo" w="100%" h="auto" py="1.5em" px="0.5em"/>
          </Link>
        </Flex>
      </Flex>


    </Box>
  );
}

export default Sidebar;